import PageConfigProvider from "src/features/PageConfigProvider";
import { FilterFieldsKeys } from "./types/FilterFields";
import useGetListParams from "./hooks/useGetListParams";
import { customSx } from "src/utils/styling";
import { Box } from "src/components/MuiGenerals";
import Filter from "./components/Filter";
import Table from "./components/Table";
import { DivideLine } from "src/utils/HelperComp";
import { getAllWalletBalanceMonitor } from "src/api/merchant";

function WalletBalanceMonitor() {
  const { getListParams } = useGetListParams();
  return (
    <PageConfigProvider
      translatePrefix="walletBalanceMonitor"
      initFields={{
        [FilterFieldsKeys.ChainName]: "",
        [FilterFieldsKeys.Currency]: "",
        [FilterFieldsKeys.WalletAddress]: "",
      }}
      getListParams={getListParams}
      getTableDataApiFunc={getAllWalletBalanceMonitor}
    >
      <Box sx={customSx.layoutBox}>
        <Filter />
        <DivideLine />
        <Table />
      </Box>
    </PageConfigProvider>
  );
}

export default WalletBalanceMonitor;
